import { action } from 'satcheljs';

export interface TriggerRetryDecryptionActionMessage {
    itemId: string;
}

const triggerRetryDecryption: (itemId: string) => TriggerRetryDecryptionActionMessage = action(
    'triggerRetryDecryption',
    (itemId: string): TriggerRetryDecryptionActionMessage => ({
        itemId,
    })
);

export default triggerRetryDecryption;
